import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import {
    FormControl, FormLabel, RadioGroup, FormControlLabel,
    Radio, Tooltip, InputAdornment, TextField
} from '@mui/material';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import InfoIcon from "@mui/icons-material/Info";
import AbcIcon from '@mui/icons-material/Abc';
import PinIcon from '@mui/icons-material/Pin';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import CameraFrontIcon from '@mui/icons-material/CameraFront';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import Select from '@mui/material/Select';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

type Field = {
    id: string;
    label: string;
    required: boolean;
    value: string;
    options: string[];
    error?: string;
    length?: string | number;
    type?: string;
    validations?: string[] | boolean;
};

type Fields = {
    fields: Field;
};

type SelectChangeEvent3 = {
    target: {
        name: string;
        checked: boolean;
    };
}

const icons: { [key: string]: JSX.Element } = {
    "1": <AbcIcon style={{ marginLeft: 4 }} />,
    "3": <AlternateEmailIcon style={{ marginLeft: 4 }} />,
    "8": <PhoneIphoneIcon style={{ flexShrink: 0 }} />,
    "9": <LocalPhoneIcon style={{ flexShrink: 0 }} />,
    "10": <AttachFileIcon style={{ flexShrink: 0 }} />,
    "11": <AttachFileIcon style={{ flexShrink: 0 }} />,
    "12": <AttachFileIcon style={{ flexShrink: 0 }} />,
    "20": <CameraFrontIcon style={{ flexShrink: 0 }} />,
    "21": <AttachFileIcon style={{ flexShrink: 0 }} />,
    "22": <AttachFileIcon style={{ flexShrink: 0 }} />,
    "23": <AttachFileIcon style={{ flexShrink: 0 }} />,
    "24": <AttachFileIcon style={{ flexShrink: 0 }} />,
    "25": <AttachFileIcon style={{ flexShrink: 0 }} />
}

export const CreateFieldQuestion = ({ fields }: Fields) => {

    return (
        <>
            <TextField
                fullWidth
                sx={{
                    '& .MuiOutlinedInput-root': {
                        height: 45,
                        '& input': {
                            height: '100%',
                            boxSizing: 'border-box',
                            padding: '0 14px',
                            alignItems: 'center',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        '&.Mui-disabled': {
                            '& fieldset': {
                                borderColor: '#6B7280',
                            },
                        },
                        '&.Mui-error': {
                            '& fieldset': {
                                borderColor: 'red',
                            },
                        },
                    },
                    '& .MuiInputLabel-root': {
                        top: '-6px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block',
                        maxWidth: 'calc(100% - 24px)',
                        '&.Mui-disabled': {
                            color: fields.error ? 'red' : '#6B7280',
                        },
                    },
                }}
                label={
                    <div style={{ display: 'flex', alignItems: 'center' }} >

                        <Tooltip title={fields.label} placement="top" arrow>
                            <span style={{
                                display: 'block',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%'
                            }}>
                                {fields.error ? (
                                    fields.error
                                ) : (
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                                        {fields.label}

                                        {fields.type && icons[fields.type] ? (
                                            (<> {icons[fields.type]} {fields.id === '0' ? <PinIcon style={{ marginLeft: 4 }} /> : null} </>)
                                        ) : (
                                            <PinIcon style={{ marginLeft: 4 }} />
                                        )}
                                    </span>
                                )}
                            </span>
                        </Tooltip>
                    </div>
                }
                value={fields.value || ''}
                error={!!fields.error}
                disabled
                variant="outlined"
                margin="none"
                InputProps={{
                    endAdornment: (
                        fields.value && fields.value.length >= 50 &&
                        <InputAdornment position="end">
                            <Tooltip title={fields.value} placement="right">
                                <InfoIcon sx={{ color: 'gray', fontSize: 18 }} />
                            </Tooltip>
                        </InputAdornment>
                    ),
                    readOnly: true,
                    style: { pointerEvents: 'none' },
                }}
            />
        </>
    )
}

export const CreateFieldAttachments = ({ fields }: Fields) => {

    return (
        <TextField
            fullWidth
            sx={{
                '& .MuiOutlinedInput-root': {
                    height: 45,
                    '& input': {
                        height: '100%',
                        boxSizing: 'border-box',
                        padding: '0 14px',
                        alignItems: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                    '&.Mui-error': {
                        '& fieldset': {
                            borderColor: 'red',
                        },
                    },
                    '&.Mui-disabled': {
                        '& fieldset': {
                            borderColor: fields.error ? 'red' : '#6B7280',
                        },
                    },
                },
                '& .MuiInputLabel-root': {
                    top: '-6px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                    maxWidth: 'calc(100% - 24px)',
                    '&.Mui-disabled': {
                        color: fields.error ? 'red' : '#6B7280',
                    },
                },
            }}
            label={
                <div style={{ display: 'flex', alignItems: 'center' }} >

                    <Tooltip title={fields.label} placement="top" arrow>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            justifyContent: 'space-between',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}>
                            <span style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                flexGrow: 1,
                                marginRight: '8px',
                            }}>
                                {fields.error ? (
                                    <>
                                        {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                                        {fields.error}
                                    </>
                                ) : (
                                    <>
                                        {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                                        {fields.label}

                                    </>
                                )}
                            </span>
                            <AttachFileIcon style={{ flexShrink: 0 }} />
                        </div>
                    </Tooltip>
                </div>
            }
            error={!!fields.error}
            disabled
            variant="outlined"
            margin="none"
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {(fields.validations === true || (Array.isArray(fields.validations) && fields.validations.length > 0)) &&
                            (fields.type === '20' || fields.type === '21') && (
                                <Tooltip title="Validação ativa" placement="top" arrow>
                                    <DoneOutlineIcon sx={{ color: 'green' }} />
                                </Tooltip>
                            )}

                    </InputAdornment>
                ),
                readOnly: true,
                style: { pointerEvents: 'none' },
            }}
        />
    )
}

export const CreateFieldImages = ({ fields }: Fields) => {

    return (
        <TextField
            fullWidth
            sx={{
                '& .MuiOutlinedInput-root': {
                    height: 45,
                    '& input': {
                        height: '100%',
                        boxSizing: 'border-box',
                        padding: '0 14px',
                        alignItems: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                    '&.Mui-error': {
                        '& fieldset': {
                            borderColor: 'red',
                        },
                    },
                    '&.Mui-disabled': {
                        '& fieldset': {
                            borderColor: fields.error ? 'red' : '#6B7280',
                        },
                    },
                },
                '& .MuiInputLabel-root': {
                    top: '-6px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                    maxWidth: 'calc(100% - 24px)',
                    '&.Mui-disabled': {
                        color: fields.error ? 'red' : '#6B7280',
                    },
                },
            }}
            label={
                <div style={{ display: 'flex', alignItems: 'center' }} >

                    <Tooltip title={fields.label} placement="top" arrow>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            justifyContent: 'space-between',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}>
                            <span style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                flexGrow: 1,
                                marginRight: '8px',
                            }}>
                                {fields.error ? (
                                    <>
                                        {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                                        {fields.error}
                                    </>
                                ) : (
                                    <>
                                        {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                                        {fields.label}
                                    </>
                                )}
                            </span>

                            {fields.type !== '19' ? icons[fields.type!] : <HistoryEduIcon style={{ flexShrink: 0 }} />}

                        </div>
                    </Tooltip>
                </div>
            }
            error={!!fields.error}
            disabled
            variant="outlined"
            margin="none"
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {(fields.validations === true || (Array.isArray(fields.validations) && fields.validations.length > 0)) &&
                            (fields.type === '20' || fields.type === '21') && (
                                <Tooltip title="Validação ativa" placement="top" arrow>
                                    <DoneOutlineIcon sx={{ color: 'green' }} />
                                </Tooltip>
                            )}

                    </InputAdornment>
                ),
                readOnly: true,
                style: { pointerEvents: 'none' },
            }}
        />
    )
}

export const CreateFieldDate = ({ fields }: Fields) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <FormControl fullWidth error={!!fields.error} sx={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: !!fields.value ? '-3px' : 0, padding: 0, overflow: 0 }}>
                <DemoContainer
                    components={['DateField', 'DateField', 'DatePicker']}
                    sx={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: !!fields.value ? '-3px' : 0, padding: 0, overflow: 0 }}>

                    <DateField
                        sx={{
                            flex: 1,
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                height: '45px',
                                '& fieldset': {
                                    borderColor: !!fields.error ? 'red' : 'default',
                                },
                                '&:hover fieldset': {
                                    borderColor: !!fields.error ? 'red' : 'default',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: !!fields.error ? 'red' : 'default',
                                },
                                '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                                    borderColor: !!fields.error ? 'red' : 'default',
                                },
                                '&.Mui-disabled': {
                                    '& fieldset': {
                                        borderColor: fields.error ? 'red' : '#6B7280',
                                    },
                                },
                            },
                            '& .MuiInputBase-input': {
                                height: '100%',
                            },
                            '& .MuiInputBase-input.Mui-disabled': {
                                WebkitTextFillColor: fields.error ? 'red' : '#6B7280',
                            },

                            '& .MuiFormLabel-root': {
                                color: !!fields.error ? 'red' : '#6B7280',
                            },
                            '& .MuiFormLabel-root.Mui-error': {
                                color: !!fields.error ? 'red' : '#6B7280',
                            },
                        }}

                        label={
                            <span>
                                {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}> *</span>}
                                {fields.label || fields.error}
                            </span>
                        }
                        defaultValue={dayjs(fields.value)}
                        format="DD-MM-YYYY"
                        disabled
                        InputProps={{
                            readOnly: true,
                            style: { pointerEvents: 'none' },
                        }}
                    />
                </DemoContainer>
            </FormControl>
        </LocalizationProvider>
    );
}

export const CreateFieldRadioButton = ({ fields }: Fields) => {

    return (
        <Box sx={{
            width: '100%',
            height: '100%'
        }}>
            <FormControl
                error={!!fields.error}
                component="fieldset"
                sx={{ display: 'flex', width: '100%' }}
            >
                <FormLabel component="legend">
                    {<span style={{ display: 'flex', wordBreak: 'break-word', color: fields.error ? 'red' : '#6B7280', }}>
                        {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                        {fields.label}{fields.error ? ` - ${fields.error}` : ''}
                    </span>}
                </FormLabel>
                <RadioGroup
                    sx={{ display: 'flex', width: '100%' }}
                    aria-label={fields.label}
                    name="radio-buttons-group"
                    value={fields.value}
                >

                    {
                        !fields.value && fields.options && (
                            <>
                                {fields.options.slice(0, 5).map((option: string, index: number) => (
                                    <FormControlLabel
                                        sx={{ display: 'flex', width: '100%', wordBreak: 'break-word' }}
                                        key={`radio-option-${index}`}
                                        value={option}
                                        disabled
                                        control={<Radio />}
                                        label={option.length >= 90 ? (`${option.slice(0, 90)}...`) : option}
                                    />
                                ))}

                                {fields.options.length > 5 && (
                                    <h4 style={{ color: 'rgba(0, 0, 0, 0.26)' }}>+ {fields.options.length - 5} opções</h4>
                                )}
                            </>
                        )
                    }

                    {fields.value && fields.options && fields.options.map((option: string, index: number) => (
                        <FormControlLabel
                            sx={{ display: 'flex', alignItems: 'center', width: '100%', wordBreak: 'break-word' }}
                            key={`radio-option-${index}`}
                            value={option}
                            disabled
                            control={<Radio />}
                            label={option.length >= 90 ? (`${option.slice(0, 90)}...`) : option}
                        />
                    ))}

                </RadioGroup>
            </FormControl>
        </Box>
    )
}

export const CreateFieldSelect = ({ fields }: Fields) => {

    return (
        <>
            <Box sx={{ width: '100%', height: '100%' }}>
                <FormControl fullWidth error={!!fields.error}>
                    <InputLabel id="demo-controlled-open-select-label" sx={{ marginTop: '-4px' }}>
                        <span style={{ display: 'flex', alignItems: 'center', wordBreak: 'break-word', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: fields.error ? 'red' : '#6B7280', }}>
                            {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                            {fields.label}{fields.error ? ` - ${fields.error}` : ''}
                        </span>
                    </InputLabel>

                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={fields.value || ''}
                        label={fields.label}
                        disabled
                        sx={{
                            height: '45px',
                            wordBreak: 'break-word',
                            width: '100%',
                            '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                borderColor: fields.error ? 'red' : '#6B7280',
                            },
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxWidth: '20%',
                                    '& li': {
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '100%',
                                        display: 'block',
                                    },
                                },
                            },
                            disableScrollLock: true
                        }}

                    >
                        {fields.options && fields.options.map((value: string, index: number) => (
                            <MenuItem
                                key={index}
                                value={value}
                                sx={{
                                    wordBreak: 'break-all',
                                    display: 'flex',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {value}
                            </MenuItem>
                        ))}

                    </Select>

                </FormControl>
            </Box>

        </>
    );
}

export const CreateFieldCheckBox = ({ fields }: Fields) => {
    const [options, setOptions] = useState<{ [key: string]: boolean }>({});

    const handleChange = (event: SelectChangeEvent3) => {
        setOptions({
            ...options,
            [event.target.name]: event.target.checked,
        });
    };

    return (
        <Box sx={{
            width: '100%',
            height: '100%',
        }}>
            <FormControl fullWidth error={!!fields.error} component="fieldset">
                <FormLabel component="legend">
                    <span style={{ display: 'flex', alignItems: 'center', wordBreak: 'break-word', color: fields.error ? 'red' : '#6B7280', }}>
                        {fields.required && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                        {fields.label}{fields.error ? ` - ${fields.error}` : ''}
                    </span>
                </FormLabel>
                <FormGroup>

                    {
                        !fields.value && fields.options && (
                            <>
                                {fields.options.slice(0, 5).map((value: string, index: number) => (
                                    <FormControlLabel
                                        key={index}
                                        sx={{
                                            wordBreak: 'break-word'
                                        }}
                                        control={
                                            <Checkbox
                                                name={value}
                                                onChange={handleChange}
                                                disabled
                                            />
                                        }
                                        label={value.length >= 90 ? (`${value.slice(0, 90)}...`) : value}
                                    />
                                ))}

                                {fields.options.length > 5 && (
                                    <h4 style={{ color: 'rgba(0, 0, 0, 0.26)' }}>+ {fields.options.length - 5} opções</h4>
                                )}
                            </>
                        )
                    }


                    {fields.value && fields.options && fields.options.map((value: string, index: number) => (

                        <FormControlLabel
                            key={index}
                            sx={{
                                wordBreak: 'break-word'
                            }}
                            control={
                                <Checkbox
                                    name={value}
                                    checked={
                                        options[value]
                                            ? options[value]
                                            : (fields.value && fields.value.includes(value)) || false
                                    }
                                    onChange={handleChange}
                                    disabled
                                />
                            }
                            label={value.length >= 90 ? (`${value.slice(0, 90)}...`) : value}
                        />
                    ))}
                </FormGroup>
            </FormControl>
        </Box >
    )
}

export function CreateFieldSection({ fields }: Fields) {

    return (
        <>
            <TextField
                fullWidth
                sx={{
                    '& .MuiOutlinedInput-root': {
                        height: 45,
                        '& input': {
                            height: '100%',
                            border: '1px dashed #6B7280',
                            borderRadius: '8px',
                            padding: '0 14px',
                            alignItems: 'center',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        '& fieldset': {
                            border: 'none',
                        },
                        '&.Mui-error': {
                            '& fieldset': {
                                borderColor: 'red',
                            },
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: fields.error ? 'red' : '#6B7280',
                        top: '-6px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block',
                        maxWidth: 'calc(100% - 24px)',

                    },
                }}
                label={fields.error ? (
                    fields.error
                ) : (
                    fields.label
                )}
                error={!!fields.error}
                InputProps={{
                    endAdornment: (
                        fields.value && fields.value.length >= 50 &&
                        <InputAdornment position="end">
                            <Tooltip title={fields.value} placement="right">
                                <InfoIcon sx={{ color: 'gray', fontSize: 18 }} />
                            </Tooltip>
                        </InputAdornment>
                    ),
                    readOnly: true,
                    style: { pointerEvents: 'none' },
                }}
            />
        </>
    );
}

export function CreateFullAdress({ fields }: Fields) {
    const InputAdress = ({ label }: { label: string }) => {
        const labelTranslate = label === 'Cidade' ? 'localidade' : label
        let fieldValue = (fields.value as any)?.[labelTranslate.toLowerCase()] ?? "";

        return (
            <>
                <TextField
                    fullWidth
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            height: 45,
                            '& input': {
                                height: '100%',
                                boxSizing: 'border-box',
                                padding: '0 14px',
                                alignItems: 'center',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            },
                            '&.Mui-disabled': {
                                '& fieldset': {
                                    borderColor: '#6B7280',
                                },
                            },
                            '&.Mui-error': {
                                '& fieldset': {
                                    borderColor: 'red',
                                },
                            },
                        },
                        '& .MuiInputLabel-root': {
                            top: '-6px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'block',
                            maxWidth: 'calc(100% - 24px)',
                            '&.Mui-disabled': {
                                color: fields!.error ? 'red' : '#6B7280',
                            },
                        },
                    }}
                    label={
                        <div style={{ display: 'flex', alignItems: 'center' }} >

                            <Tooltip title={label} placement="top" arrow>
                                <span style={{
                                    display: 'block',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '100%'
                                }}>
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        {fields!.required && label !== 'Complemento' && <span style={{ color: 'red', fontSize: '1.2em' }}>*</span>}
                                        {label}
                                    </span>
                                </span>
                            </Tooltip>
                        </div>
                    }
                    value={fieldValue || ''}
                    error={!!fields!.error}
                    disabled
                    variant="outlined"
                    margin="none"
                    InputProps={{
                        readOnly: true,
                        style: { pointerEvents: 'none' },
                    }}
                />
            </>
        )
    }

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    gap: fields.value ? '20px' : '5px',
                    //border: '1px solid #6B7280', 
                    //borderRadius: '8px',
                }}
            >
                <InputAdress label='Cep' />
                <InputAdress label='Logradouro' />
                <InputAdress label='Número' />
                <InputAdress label='Complemento' />
                <InputAdress label='Bairro' />
                <InputAdress label='Cidade' />
                <InputAdress label='Estado' />

            </Box>
        </>
    )
}

export const choicesFields = [
    { "id": '0', 'value': (fields: Field) => <CreateFieldQuestion fields={fields} /> },
    { "id": '1', 'value': (fields: Field) => <CreateFieldAttachments fields={fields} /> },
    { "id": '2', 'value': (fields: Field) => <CreateFieldImages fields={fields} /> },
    { "id": '3', 'value': (fields: Field) => <CreateFieldDate fields={fields} /> },
    { "id": '4', 'value': (fields: Field) => <CreateFieldRadioButton fields={fields} /> },
    { "id": '5', 'value': (fields: Field) => <CreateFieldSelect fields={fields} /> },
    { "id": '6', 'value': (fields: Field) => <CreateFieldCheckBox fields={fields} /> },
    { "id": '7', 'value': (fields: Field) => <CreateFieldSection fields={fields} /> },
    { "id": '8', 'value': (fields: Field) => <CreateFullAdress fields={fields} /> }
]

export const optionsFields = [
    { id: '0', id_choice: "0", label: "Texto", type: "1", length_label: 200, length_value: 200 },
    { id: '8', id_choice: "0", label: "Numérico", type: "2", length_label: 200, length_value: 80 },
    { id: '1', id_choice: "0", label: "Nome", type: "1", length_label: 200, length_value: 80 },
    { id: '2', id_choice: "8", label: "CEP (ENDEREÇO COMPLETO)", type: "26", length_label: 150, length_value: 100 },
    { id: '9', id_choice: "0", label: "Email", type: "3", length_label: 200, length_value: 80 },
    { id: '10', id_choice: "0", label: "CPF", type: "4", length_label: 200 },
    { id: '11', id_choice: "0", label: "CNPJ", type: "6", length_label: 200 },
    { id: '12', id_choice: "3", label: "Data", type: "5", length_label: 100 },
    { id: '13', id_choice: "3", label: "Data de Nascimento", type: "5", length_label: 100 },
    { id: '14', id_choice: "0", label: "Celular", type: "8", length_label: 200 },
    { id: '15', id_choice: "0", label: "Telefone Residencial", type: "9", length_label: 200 },
    { id: '16', id_choice: "4", label: "Radio", type: "16", length_label: 150, length_value: 100 },
    { id: '17', id_choice: "5", label: "Select", type: "13", length_label: 150, length_value: 100 },
    { id: '18', id_choice: "6", label: "Checkbox", type: "15", length_label: 150, length_value: 100 }
];

export const optionsAttachments = [
    { id: '19', id_choice: "1", label: "Arquivos", type: "10", length_label: 100 },
    { id: '21', id_choice: "2", label: "Somente Câmera (mobile)", type: "12", length_label: 100 },
    { id: '22', id_choice: "2", label: "Assinatura", type: "19", length_label: 100 },
    { id: '23', id_choice: "1", label: "Selfie", type: "20", length_label: 100 },
    { id: '24', id_choice: "1", label: "CNH", type: "21", length_label: 100 },
    { id: '25', id_choice: "1", label: "RG - Frente", type: "22", length_label: 100 },
    { id: '26', id_choice: "1", label: "RG - Verso", type: "23", length_label: 100 },
    { id: '27', id_choice: "1", label: "Comprovante de Residência", type: "24", length_label: 100 },
    { id: '28', id_choice: "1", label: "Holerite", type: "25", length_label: 100 },
];

export const optionSection = { id: '27', id_choice: "7", label: "Seção", type: "18", length_label: 150 }
